import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';

const TabsContainer = styled.ul`
  display: flex;
  padding: ${theme.spacings[4].rem} 0;
  margin: 0;
  list-style: none;
  overflow: auto;

  ${breakpoint('lg')`
    overflow: hidden;
  `}
`;

export const Tabs: React.FC<PropsWithChildren> = ({ children }) => {
  return <TabsContainer>{children}</TabsContainer>;
};
